import axios from 'axios';

/**
 * Dispara evento para workflow Camunda
 */
export async function handleJSCode(action, formData, config, token) {
  if(!token) throw new Error('No token provided')
  const endpoint = action.replace('jscode:', '');
  const payload = {...config.payload, ...formData};
  try{
    const { data } = await axios.post(
      `${process.env.REACT_APP_MEVIO_APIENDPOINT}v2/jscode/run`,
      { endpoint, payload },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          apikey: `${process.env.REACT_APP_MEVIO_APIKEY}`
        }
      }
    );
    console.log(`✅ Code '${endpoint}' executado.`);
    return data
  }catch(e){
    throw e
  }
}
